/**
 * The loading spinner [Figma · component 1818:5936].
 *
 * Drawn in CSS rather than from the two exported SVG arcs. The asset rule in the design-to-code workflow is
 * about *content* — logos, icons, illustrations — and this is a rotating ring with no glyph: the exported
 * pair is a static snapshot of one frame of an animation, so using it would give a spinner that does not
 * spin. The geometry (48px, ring on `--primary`) is taken from the frame.
 *
 * `motion-reduce:animate-none` because a candidate with vestibular sensitivity should not be handed a
 * spinning element they cannot dismiss on an unattended device.
 */
export function Spinner() {
  return (
    <div
      /* `size-12` = 48px, which is the number the note above already cites. It was `size-10`, so the
         spinner drew 40 against a component that measures 48 — the code disagreeing with its own
         documented frame value. Border-box, so `border-4` is inside the 48 rather than added to it. */
      className="size-12 animate-spin rounded-full border-4 border-solid border-[var(--primary-muted)] border-t-[var(--primary)] motion-reduce:animate-none"
      role="presentation"
    />
  );
}
